import { render, staticRenderFns } from "./ListIgnored.vue?vue&type=template&id=108cd466&"
import script from "./ListIgnored.vue?vue&type=script&lang=js&"
export * from "./ListIgnored.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports